<div class="tab-container">
    <div class="row mt-2">
        <div class="card card-min no-border">
            <div class="im-card-tab-menu">
                <div class="im-list-group leftSidebar" *ngFor="let item of menuItems">
                    <a class="im-list-group-item" (click)="handleKeySelection(item.key)"
                        [ngClass]="item.key === employeeTab ? 'activeItem' : 'inActiveItem' ">
                        <span>{{ item.value }} </span></a>
                </div>
            </div>
        </div>
        <div class="col-md pr-0" *ngIf="employeeTab === 'EMPINFO'">
            <div class="page-caption row">
                <div class="col-md-8 px-0">
                    <h5 class="mb-0">Section 1 - Employee Information</h5>
                    <!-- <small class="link" (click)="backToDashboard()">
                        << BACK </small> -->
                </div>
                <div class="col-md-4 px-0 justify-content-end d-flex">
                    <button type="button" class="btn btn-primary add-btn" (click)="addI9Doc()"> <i
                            class="pi pi-upload"></i> UPLOAD DOCUMENTS</button>
                </div>
            </div>
            <div class="mat-elevation-z8 mt-3 manage-case-status">
                <div class="row py-0">
                    <div class="col-md-6 pt-3 pb-3 justify-content-end">
                        <div class="search-btn">
                            <div class="input-group">
                                <h6>Uploaded I-9 Section 1 Documents</h6>
                                <!-- <p-dropdown (onChange)="selectFormChanges()" [options]="formList"
                                    [(ngModel)]="selectFotmtype" optionValue="id" placeholder="Select Form Type"
                                    optionLabel="name" [showClear]="false"></p-dropdown> -->
                            </div>
                        </div>
                    </div>
                </div>

                <p-table [columns]="cols" class="pa-table im-card-no-border-table im-card-table-noborder-spacing table"
                    styleClass="p-datatable-gridlines" [value]="pastDocumentsList" dataKey="id">

                    <ng-template pTemplate="header" let-columns>
                        <tr class="">
                            <th style="width: 1.5rem;padding: 0 !important;"></th>
                            <th *ngFor="let col of columns" [style.width]="col.width" [attr.class]="col.cssClass">
                                {{col.header}}
                            </th>
                            <th width="10%" class="text-center">Actions</th>
                        </tr>
                    </ng-template>


                    <ng-template pTemplate="body" let-item let-columns="columns">
                        <tr>
                            <td></td>
                            <td *ngFor="let col of columns">
                                <span>
                                    {{item[col.field]}}
                                </span>
                                <span *ngIf="col.field === 'createdBy'">
                                    {{item['createdBy']['dateTime']}}
                                </span>
                            </td>

                            <td>
                                <div class="d-flex justify-content-center">
                                    <button pButton type="button" aria-label="View" icon="pi pi-eye"
                                        (click)="viewPastDoc(item)" pTooltip="View" class="p-button-text"></button>
                                    <button pButton type="button" aria-label="View" icon="pi pi-download"
                                        (click)="downloadPastDoc(item)" pTooltip="Download"
                                        class="p-button-text"></button>
                                    <p-divider layout="vertical"></p-divider>
                                    <button pButton type="button" aria-label="Edit" icon="pi pi-pencil"
                                        (click)="editPastDoc(item)" pTooltip="Edit" class="p-button-text"></button>
                                    <button pButton type="button" aria-label="Delete" icon="pi pi-trash"
                                        pTooltip="Delete" class="p-button-text"
                                        (click)="confirmPastDocDelete(item)"></button>
                                </div>
                            </td>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="emptymessage" let-columns>
                        <tr>
                            <td [attr.colspan]="9" class="text-center">
                                No Data Available
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
                <p-paginator [rows]="pageSize" (onPageChange)="paginationEvent($event)"
                    *ngIf="this.pastDocumentsList?.length > 0" [totalRecords]="totalElementCount"
                    [rowsPerPageOptions]="pageSizeOptions" length="totalElementCount">
                </p-paginator>
            </div>
            <p-confirmDialog header="Delete" key="deletePastDoc"></p-confirmDialog>
        </div>
        <div class="col-md-pr-0" *ngIf="employeeTab === 'EMPREVIEW'">
           <h6>Comping Soon Employee ReView</h6>
        </div>
        <div class="col-md-pr-0" *ngIf="employeeTab === 'EMPREVERIFICATION'">
            <h6>Comping Soon Employee Re-Verification</h6>
        </div>
    </div>

</div>